import { type DocumentType, graphql } from '@generated/gql';

export const EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS = graphql(
  /** GraphQL */ `
  query editAccountAllocationsFetchPortfolioReports($input: FetchPortfolioReportsInput!) {
    fetchPortfolioReports(input: $input) {
      portfolioReports {
        id
        expectedCashPercentage
        modelPortfolio {
          strategy
        }
        holdings {
          expectedPercentage
          isCashEquivalent
          customExpectedPercentage
          assetClassPercentage
          assetClassGroupPercentage
          assetClass {
            id
            name
            translatedName {
              en
              fr
              es
            }
          }
          financialProduct {
            id
            ticker
            translatedName {
              en
              fr
              es
            }
            isCash
          }
        }
        subAccounts {
          id
          marketValueCents
          subAccount {
            id
            state
            account {
              id
              custodianAccountNumber
              type
              user {
                firstName
                lastName
                entityName
              }
            }
          }
          holdings {
            expectedPercentage
            isCashEquivalent
            customExpectedPercentage
            assetClassPercentage
            assetClassGroupPercentage
            assetClass {
              id
              name
              translatedName {
                en
                fr
                es
              }
            }
            financialProduct {
              id
              ticker
              translatedName {
                en
                fr
                es
              }
              isCash
            }
          }
        }
      }
    }
  }
`,
);

export type EditAccountAllocationsPortfolioReport = DocumentType<
  typeof EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS
>['fetchPortfolioReports']['portfolioReports'][number];
